module.exports = __webpack_public_path__ + "img/28.52524722.gif";